// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--JKHXX","link_redesign":"_93444fe79c--link_redesign--D8J2I"};